import React from 'react';
import { Icon } from '@savewatersavemoney/swsm-ui';
import i18next from 'i18next';
import Select from 'react-select';
import { isLoggedIn, getVariable } from '../../helpers';
import * as _ from 'lodash';
import store from 'store2';
import Styled from './LanguageSelect.style';

interface TranslationProps {
  status?: any;
  appWidth?: any;
  getPreferences: Function;
  page?: any;
  setPreferences: Function;
  app: any;
  location: any;
  getQuestions: Function;
  getLocation: Function;
  getChallenges: Function;
}

const LanguageSelect: React.FC<TranslationProps> = props => {
  const { status, app, appWidth, getPreferences, getLocation, setPreferences, getChallenges, location } = props;
  const isDesktop = appWidth > 800;
  const logged = Boolean(isLoggedIn());
  const locationLang = _.get(app, 'locationConfig.data.data.availableLanguages');
  const configLang = _.get(app, 'clientConfig.data.data.availableLanguages');
  const locationDefaultLang = _.get(app, 'locationConfig.data.data.defaultLanguage');
  const configDefaultLang = _.get(app, 'clientConfig.data.data.defaultLanguage');
  const swsmInternal = getVariable('mode', 'swsm', false);
  const localStorageLang = localStorage.getItem('i18nextLng');
  const getPostcode = store('swsmLocation');
  const getPostcode2 = _.get(getPostcode, 'postcode_store');
  const defaultLang = locationDefaultLang ? locationDefaultLang : configDefaultLang;
  const langs = locationLang ? locationLang : configLang;

  const hindiLang = [
    { code: 'en-GB', text: 'English' },
    { code: 'hi-IN', text: 'हिंदी' },
  ];
  const languages = location.pathname === '/india' ? hindiLang : langs;

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#0b2641',
      },
      borderColor: '#0b2641',
    }),
    option: (provided, state) => ({
      ...provided,
      boxShadow: 'none',
      zIndex: 999,
      '&:hover': {
        backgroundColor: 'rgb(215, 241, 255)',
        color: '#0b2641',
      },
      backgroundColor: state.isSelected && 'rgb(215, 241, 255)',
      color: state.isSelected && '#0b2641',
    }),
  };

  React.useEffect(() => {
    if (logged && status.done && !props.page.userData.data) {
      getPreferences();
    }

    if (props.page.userData.data && props.page.userData.data.language !== null) {
      i18next.changeLanguage(props.page.userData.data.language);
    }

    //check if the user is;
    //logged in and has no language currently set
    //if language has been changed from default then set the current language
    if (
      logged &&
      props.page.userData.data &&
      props.page.userData.data.language === null &&
      i18next.language !== 'en-GB'
    ) {
      setPreferences(
        {
          language: i18next.language,
        },
        () => void 0,
      );
    }

    if (!logged && status.done && !window.location.href.includes('questions')) {
      i18next.changeLanguage('en-GB');
    }
    if (location.pathname === '/india') {
      i18next.changeLanguage('hi-IN');
    }
  }, [status.done, getPreferences, logged, props.page.userData.data, setPreferences, location.pathname]);

  if (!app.locationConfig.data && !app.clientConfig.data && location.pathname !== '/india') {
    return null;
  }
  if (location.pathname === '/' || location.pathname === '/login') {
    localStorage.removeItem('i18nextLng');
  }
  if (
    (!app.locationConfig.data && !app.clientConfig.data && location.pathname !== '/india') ||
    (locationLang && locationLang.length === 1) ||
    (configLang && configLang.length === 1)
  ) {
    return null;
  }

  const createOptions = () => {
    const options =
      languages &&
      languages.map(lang => {
        return {
          value: lang.code,
          label: (
            <div
              style={{
                display: 'flex',
                alignContent: 'center',
              }}
            >
              <Icon icon={lang.code.replace('-', '')} size={30} />{' '}
              <p style={{ margin: '1px 0 0 5px', textTransform: 'uppercase' }}>{lang.text}</p>
            </div>
          ),
        };
      });

    return options;
  };

  const createDefaultLang = () => {
    const options =
      languages &&
      languages.map(lang => {
        return {
          value: lang.code,
          label: (
            <div
              style={{
                display: 'flex',
                alignContent: 'center',
              }}
            >
              <Icon icon={lang.code.replace('-', '')} size={30} />{' '}
              {isDesktop ? <p style={{ margin: '1px 0 0 5px', textTransform: 'uppercase' }}>{lang.text}</p> : null}
            </div>
          ),
        };
      });

    return options;
  };

  const getCurrent = data => {
    if (!data && i18next.language === 'en-GB') {
      const index = createOptions().findIndex(el => {
        return el.value.toLowerCase() === 'en-GB';
      });
      return index;
    }
    if (location.pathname === '/india') {
      const index = createOptions().findIndex(el => {
        return el.value === 'hi-IN';
      });
      return index;
    }
    if (data) {
      const index = createOptions().findIndex(el => {
        return el.value.toLowerCase() === data.toLowerCase();
      });
      return index;
    }
    const index = createOptions().findIndex(el => {
      return el.value.toLowerCase() === i18next.language.toLowerCase();
    });
    return index;
  };

  const handleChange = event => {
    i18next.changeLanguage(event);

    if (location.pathname === '/questions') {
      // getQuestions(getWaterClient);
      getLocation(getPostcode2);
    }
    if (location.pathname === '/easywins') {
      getChallenges();
    }
    if (logged) {
      props.setPreferences(
        {
          language: event,
        },
        () => void 0,
      );
      setTimeout(() => {
        getPreferences();
      }, 200);
    }
  };

  return (
    <Styled.Wrap style={{ padding: !isDesktop ? '6px' : '0px' }}>
      <form autoComplete="off">
        <Select
          styles={customStyle}
          options={createOptions()}
          defaultValue={createDefaultLang()[getCurrent(swsmInternal ? localStorageLang : defaultLang)]}
          onChange={event => handleChange(event?.value)}
        />
      </form>
    </Styled.Wrap>
  );
};

export default LanguageSelect;
